export const required = value => {
  if (Array.isArray(value)) return !!value.length
  if (value === undefined || value === null) {
    return false
  }

  if (value === false) {
    return true
  }

  if (value instanceof Date) {
    return !isNaN(value.getTime())
  }

  if (typeof value === 'object') {
    for (let _ in value) { return true }
    return false
  }

  return !!String(value).length
}

export const len = value => {
  if (Array.isArray(value)) return value.length
  if (typeof value === 'object') {
    return Object.keys(value).length
  }
  return String(value).length
}

export const regex = (value, expr) => expr.test(value)
